import UnavailableProductHeader from "./UnavailableProductHeader/UnavailableProductHeader";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./UnavailableProduct.scss";
import classnamesBind from "classnames/bind";
import YouMightAlsoLike from "../youMightAlsoLike/YouMightAlsoLike";
import { isProductDiscontinued } from "../../../utils/productUtils";
import UnavailableProductSkeleton from "./UnavailableProductSkeleton";

const classnames = classnamesBind.bind(styles);

const renderLoadingElement = () => <UnavailableProductSkeleton />;

export default function UnavailableProduct() {
  const { getTranslation, product } = useRuntimeConstants();

  const discontinuedProduct = isProductDiscontinued(product);

  const headerTitle = discontinuedProduct
    ? getTranslation("pdp_discontinued_product_page_title")
    : getTranslation("pdp_unavailable_product_page_title");

  const headerSubTitle = discontinuedProduct
    ? getTranslation("pdp_discontinued_product_page_message")
    : getTranslation("pdp_unavailable_product_page_message");

  return (
    <section className={classnames(styles.section)}>
      <UnavailableProductHeader title={headerTitle} message={headerSubTitle} />
      <YouMightAlsoLike renderLoadingElement={renderLoadingElement} />
    </section>
  );
}
